module.exports = __tmimport("~load:{controller: \'customized/api\', action: \'payments_free\'}");